import { Box } from '@mui/material';
import React from 'react';
import Alert from '../../../components/alert/Alert';
import SidePanel from '../../../components/layout/SidePanel';
import { SIDE_PANEL_IDS } from '../../../constants/constants';
import I18n from '../../../i18n/I18n';
import { Icons } from '../../../icons/Icons';
import ReviewApproval from '../components/ReviewApproval';
import ReviewApprovalProvider from '../ReviewApprovalProvider';

export interface ReviewApprovalSidePanelProps {
    approvalId?: string;
    onClose: () => void;
}

export default function ReviewApprovalSidePanel({ approvalId, onClose }: ReviewApprovalSidePanelProps) {
    return (
        <SidePanel
            id={SIDE_PANEL_IDS.approvals}
            title={<I18n token="approvals.sidePanel.title" />}
            securedActions={[
                {
                    icon: Icons.Close,
                    label: <I18n token="approvals.sidePanel.close" />,
                    onClick: onClose
                }
            ]}
        >
            <Box sx={{ overflowX: 'hidden', overflowY: 'auto', width: '100%' }}>
                {!approvalId ? (
                    <Alert severity="info">
                        <I18n token="approvals.sidePanel.approvalId.missing.message" />
                    </Alert>
                ) : (
                    <ReviewApprovalProvider approvalId={approvalId} throwOnError={false}>
                        <ReviewApproval />
                    </ReviewApprovalProvider>
                )}
            </Box>
        </SidePanel>
    );
}
